import React, { useEffect, useRef, useState, useContext } from 'react';
import AdminLayout from '../../components/admin-layout';
import UserProfile from '../../components/UserProfile/UserProfile';
import { FiLogOut } from 'react-icons/fi';
import { GoArrowUpRight } from 'react-icons/go';
import SideMessageNotification from './SideMessageNotification';
import Chart from 'chart.js/auto';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import ConsultationCard from '../../components/ConsultationCard/ConsultationCard';
import { Link } from 'react-router-dom';
import Createrequest from '../../components/ConsultationCard/Createrequest';
import ViewRequest from '../../components/ConsultationCard/Viewrequest';
import {
  getDashboardApi,
  getNotificationAPI,
  getProfilebyId,
  getRecentConsltationAPI,
  getUserApi,
} from '../../apis';
import { AppContext } from '../../appContext';
import ConsultationViewRequest from '../../components/ConsultationCard/ConsultationViewRequest';
import BookingsCard from './BookingsCard';
import MonthlyCredits from './MonthlyCredits';
import ConsultationHistory from './ConsultationHistory';
import { escape } from 'lodash';
import { FaCalendarAlt } from "react-icons/fa";
import { FaVideo } from "react-icons/fa6";
import DashboardHeader from '../../PageComponent/Dashboard/DashboardHeader';
import DashboardGraphSection from '../../PageComponent/Dashboard/DashboardGraphSection';
import ConsultatinoHistoryChart from '../../PageComponent/Dashboard/ConsultatinoHistoryChart';
import MonthlyExpenditureChart from '../../PageComponent/Dashboard/MonthlyExpenditurechar';
import NoConsultation from '../../lottiefiles/no_consultation.json';
import Placeholder from '../../components/placeholder';

function DashboardOdds() {
  const [profileData, setprofileData] = useState('');
  const [RecentRequest, setRecentRequest] = useState('');
  const { setIsLoggedIn, logout, setChatCount, chatCount, weavychatcount } = useContext(AppContext);
  const [monthlydata, setmonthlydata] = useState([]);
  const [monthlylable, setmonthlylable] = useState([]);
  const [totalcreditused, settotalcreditused] = useState(0);
  const [inpersoncount, setinpersoncount] = useState(0);
  const [virtualcount, setvirtualcount] = useState(0);
  const [consultationhistorylable, setconsultationhistorylable] = useState([]);
  const [consultationhistoryremote, setconsultationhistoryremote] = useState(
    []
  );
  const [
    consultationhistoryinperson,
    setconsultationhistoryinperson,
  ] = useState([]);
  const [consultationhistorysucc, setconsultationhistorysucc] = useState([]);
  const [notificationFilter, setNotificationFilter] = useState('');
  const [
    consultationhistoryremotecount,
    setconsultationhistoryremotecount,
  ] = useState(0);
  const [
    consultationhistoryinpersoncount,
    setconsultationhistoryinpersoncount,
  ] = useState(0);
  const [
    consultationhistorysucccount,
    setconsultationhistorysucccount,
  ] = useState(0);

  const handleFilterChange = (event) => {
    setNotificationFilter(event.target.value);
    // Call getNotification function with the selected filter value
    getNotification(profileData?.hospitalProfile?._id, event.target.value);
  };
  const fetchData = async () => {
    try {
      const res = await getUserApi();
      if (res.status === 200) {
        console.log(res.data.Profile);
        getNotification(res?.data?.Profile?.hospitalProfile?._id);
        Dashboard(res?.data?.Profile?.hospitalProfile?._id);
        setprofileData(res?.data?.Profile);
        getRecentRequest(res?.data?.Profile?.hospitalProfile?._id);

        setIsLoggedIn(res?.data?.Profile);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const fullDateRanges = [
    { date_range: '1–7', sortOrder: 1, totalfee: 0 },
    { date_range: '8–14', sortOrder: 2, totalfee: 0 },
    { date_range: '15–21', sortOrder: 3, totalfee: 0 },
    { date_range: '22–28', sortOrder: 4, totalfee: 0 },
    { date_range: '29–31', sortOrder: 5, totalfee: 0 },
  ];

  const sumCategory = (data, key) =>
    data.reduce(
      (acc, item) => acc + item[key].reduce((x, y) => x + y.count, 0),
      0
    );

  const Dashboard = async (id) => {
    try {
      const res = await getDashboardApi(id);
      if (res.status === 200) {
        console.log(res.data);
        if (res?.data?.consttypecount?.length > 0) {
          setinpersoncount(res?.data?.consttypecount?.[0]?.inperson);
          setvirtualcount(res?.data?.consttypecount?.[0]?.Virtual);
        }
        if (res?.data?.MonthlyExpenditure?.length > 0) {
          var date_ranges = await res?.data?.MonthlyExpenditure?.map(
            (item) => item.date_range
          );
          console.log(date_ranges);
          const fullDateRanges = [
            { date_range: '1–7', sortOrder: 1 },
            { date_range: '8–14', sortOrder: 2 },
            { date_range: '15–21', sortOrder: 3 },
            { date_range: '22–28', sortOrder: 4 },
            { date_range: '29–31', sortOrder: 5 },
          ];
          const incomingData = res?.data?.MonthlyExpenditure;
          console.log("resultincomingdata", incomingData)
          const result = await mergeDateRangeFees(fullDateRanges, incomingData);
          console.log("resultmonthlylable", result)
          setmonthlylable(result);
          var totalCredits = await res?.data?.MonthlyExpenditure?.map(
            (item) => item.totalfee
          );
          setmonthlydata(totalCredits);
          const totalCreditCount = await res?.data?.MonthlyExpenditure?.reduce(
            (acc, usage) => acc + usage.totalfee,
            0
          );
          settotalcreditused(totalCreditCount);
        }
        if (res?.data?.completedconstdata?.length > 0) {
          const date_ranges = res.data.completedconstdata.map((item) => {
            const totalItem = item.total[0]; // Assuming there's only one item in the total array
            return `${totalItem.monthName}`;
          });
          console.log(date_ranges);
          setconsultationhistorylable(date_ranges);
          // setmonthlylable(date_ranges);

          const inperson = res.data.completedconstdata.map((item) => {
            if (item.inperson.length > 0) {
              const inpersonItem = item.inperson[0]; // Assuming there's only one item in the inperson array
              return inpersonItem.count;
            }
          });
          console.log(inperson);
          setconsultationhistoryinperson(inperson);

          const virtual = res.data.completedconstdata.map((item) => {
            if (item.Virtual.length > 0) {
              const virtualItem = item.Virtual[0]; // Assuming there's only one item in the Virtual array
              return virtualItem.count;
            }
          });
          console.log(virtual);
          setconsultationhistoryremote(virtual);
          const total = res.data.completedconstdata.map((item) => {
            if (item.total.length > 0) {
              const totalItem = item.total[0]; // Assuming there's only one item in the total array
              return totalItem.count;
            }
          });
          console.log(total);
          setconsultationhistorysucc(total);
          // const inpersonCountconst = res.data.completedconstdata.reduce(
          //   (acc, item) => {
          //     console.log(item.inperson.length);
          //     if (item.inperson.length > 0) {
          //       const inpersonItem = item.inperson[0]; // Assuming there's only one item in the inperson array
          //       return acc + inpersonItem.count;
          //     }
          //     return acc;
          //   },
          //   0
          // );
          const inpersonCountconst = sumCategory(res.data.completedconstdata, "inperson");
          console.log(inpersonCountconst);
          setconsultationhistoryinpersoncount(inpersonCountconst);
          // const virtualCountconst = res.data.completedconstdata.reduce(
          //   (acc, item) => {
          //     if (item.Virtual.length > 0) {
          //       const virtualItem = item.Virtual[0]; // Assuming there's only one item in the Virtual array
          //       return acc + virtualItem.count;
          //     }
          //     return acc;
          //   },
          //   0
          // );
          const virtualCountconst = sumCategory(res.data.completedconstdata, "Virtual");
          console.log(virtualCountconst);
          setconsultationhistoryremotecount(virtualCountconst);
          // const totalCount = res.data.completedconstdata.reduce((acc, item) => {
          //   if (item.total.length > 0) {
          //     const totalItem = item.total[0]; // Assuming there's only one item in the total array
          //     return acc + totalItem.count;
          //   }
          //   return acc;
          // }, 0);
          const totalCount = sumCategory(res.data.completedconstdata, "total");
          console.log(totalCount);
          setconsultationhistorysucccount(totalCount);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getRecentRequest = async (userId) => {
    try {
      const res = await getRecentConsltationAPI(userId);
      if (res.status === 200) {
        console.log(res.data.request);
        setRecentRequest(res.data.request);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const [notification, setnotificaiton] = useState(null);
  const getNotification = async (userId, filterval) => {
    console.log(userId);
    if (!filterval) {
      if (notificationFilter) {
        filterval = notificationFilter;
      }
      else {
        filterval = 'today';
      }
    }
    try {
      const res = await getNotificationAPI(userId, filterval);
      if (res.status === 200) {
        //console.log(res.data.hospitalNotification);
        setnotificaiton(res.data.hospitalNotification);
      }
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  const [createRequestBlock, setCreateRequestBlock] = useState(false);
  const [editRequestBlock, setEditRequestBlock] = useState(false);

  const [ViewRequestBlock, setViewRequestBlock] = useState(false);
  const [openChat, setOpenChat] = useState(false);
  function handelViewRequestBlockForNotification(data) {
    if (data?.type == 'socketmessage') {
      setOpenChat(true);
    }  else {
      setOpenChat(false);
    }
    setViewRequestBlock(!ViewRequestBlock);
    setcurrentrequest(data?.id);
  }

  function handelViewRequestBlock(data) {
    setViewRequestBlock(!ViewRequestBlock);
    setcurrentrequest(data);
  }

  function handelCreateRequestBlock() {
    setCreateRequestBlock(!createRequestBlock);
  }
  const [currentrequest, setcurrentrequest] = useState(null);
  function handelEditRequestBlock(data) {
    setEditRequestBlock(!editRequestBlock);
    setcurrentrequest(data?._id);
  }


  let consultationBlock = null; // Declare consultationBlock outside the conditional block

  if (RecentRequest && RecentRequest?.length > 0) {
    consultationBlock = RecentRequest?.map((data, i) => (
      <ConsultationCard
        data={data}
        ViewRequest={() => {
          handelViewRequestBlock(data?._id);
        }}
        editRequest={() => {
          handelEditRequestBlock(data);
        }}
        onload={fetchData}
        fillBtnTitle="View Request"
        unFillBtnTitle="Delete"
        fillBtnfun={() => {
          handelViewRequestBlock(data?._id);
        }}
      />
    ));
  }
  else {
    consultationBlock = (
      <div className="border bg-white rounded rounded-lg pt-4 pb-4 flex items-center justify-center mb-28">
        <Placeholder
      title='No requests found.'
      animationData={NoConsultation}
       message="No consultation requests were found at this time."
      />
      </div>
       
    );
  }
  const consultationHistoryData = [
    { name: 'Remote', value: consultationhistoryremotecount || 0, color: '#F1D17A' },
    { name: 'In-person', value: consultationhistoryinpersoncount || 0, color: '#F588E2' },
    { name: 'Successful', value: consultationhistorysucccount || 0, color: '#B7AFFF' },
  ];



  function normalizeDateRange(str) {
    return str.replace(/–/g, '-'); // convert en dash to hyphen
  }

  function mergeDateRangeFees(fullDateRanges, incomingData) {
    return fullDateRanges.map(item => {
      const normalizedItemRange = normalizeDateRange(item.date_range);
      const match = incomingData.find(
        d => normalizeDateRange(d.date_range) === normalizedItemRange
      );
      return {
        ...item,
        totalfee: match ? match.totalfee : 0,
      };
    });
  }
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <AdminLayout>
      <DashboardHeader
        profileData={profileData}
      />
      <main>

        {/* <DashboardGraphSection /> */}
        {/* Dashboard sm screen start */}
        <div className="md:hidden p-4 mb-16 bg-bodycolor dashboardSmDevices">

          <div className='flex flex-wrap gap-4 justify-center '>
            <BookingsCard
              icon={<FaCalendarAlt size={21} />}
              //imgUrl={require('../../Assets/img/odds/calender.png')}
              bookingTitle={'In-person Bookings'}
              bookingCount={inpersoncount}
              bookingPercentage={'4.8%'}
              bookingFromDate={'from last week'}
            />
            <BookingsCard
              icon={<FaVideo size={21} />}
              // imgUrl={require('../../Assets/img/odds/virtualbookings.png')}
              bookingTitle={'Virtual Bookings'}
              bookingCount={virtualcount}
              bookingPercentage={'10.8%'}
              bookingFromDate={'from last week'}
            />
            {/* <MonthlyCredits
               monthlydata={monthlydata}
               monthlylable={monthlylable}
               totalCreditCount={totalcreditused}
             /> */}

            {
              monthlylable.length > 0 ?
                (<MonthlyExpenditureChart data={monthlylable} />) : (<MonthlyExpenditureChart data={fullDateRanges} />)

            }

            <ConsultatinoHistoryChart arrdata={consultationHistoryData} />
            {/* <ConsultationHistory
               consultationhistorylable={consultationhistorylable}
               consultationhistoryremote={consultationhistoryremote}
               consultationhistoryinperson={consultationhistoryinperson}
               consultationhistorysucc={consultationhistorysucc}
               consultationhistoryremotecount={consultationhistoryremotecount}
               consultationhistoryinpersoncount={
                 consultationhistoryinpersoncount
               }
               consultationhistorysucccount={consultationhistorysucccount}
             /> */}
          </div>

          <section className="mt-14 mb-14">
            <div className="flex justify-between items-center mb-4">
              <p className="text-coalBlack subHeadingText capitalize">
                Request History
              </p>
              <Link to={'/consultation'}>
                <p className="capitalize smallText text-navLink">
                  see all
                </p>
              </Link>
            </div>
            <div className="space-y-3">{consultationBlock}</div>
          </section>
        </div>
        {/* Dashboard sm screen end */}
        {/* Dashboard large screen start */}
        <div className="mt-6 p-4 hidden md:block">
          <div className="grid grid-cols-12 gap-4  py-4 xl:px-8 xl:pb-0">
            <div className="col-span-12 xl:col-span-8 ">
              <div className="grid grid-cols-1 gap-4 sm:grid-cols-2  3xl:grid-cols-2 place-content-stretch ">
                <BookingsCard
                  icon={<FaCalendarAlt size={21} />}
                  // imgUrl={require('../../Assets/img/odds/calender.png')}
                  bookingTitle={'In-person Bookings'}
                  bookingCount={inpersoncount}
                  bookingPercentage={'4.8%'}
                  bookingFromDate={'from last week'}
                />

                <BookingsCard
                  icon={<FaVideo size={21} />}
                  // imgUrl={require('../../Assets/img/odds/virtualbookings.png')}
                  bookingTitle={'Virtual Bookings'}
                  bookingCount={virtualcount}
                  bookingPercentage={'10.8%'}
                  bookingFromDate={'from last week'}
                />
                {
                  monthlylable.length > 0 ?
                    (<MonthlyExpenditureChart data={monthlylable} />) : (<MonthlyExpenditureChart data={fullDateRanges} />)

                }

                <ConsultatinoHistoryChart arrdata={consultationHistoryData} />

                {/* <MonthlyCredits
                 monthlydata={monthlydata}
                 monthlylable={monthlylable}
                 totalCreditCount={totalcreditused}
               />
        
               <ConsultationHistory
                 consultationhistorylable={consultationhistorylable}
                 consultationhistoryremote={consultationhistoryremote}
                 consultationhistoryinperson={consultationhistoryinperson}
                 consultationhistorysucc={consultationhistorysucc}
                 consultationhistoryremotecount={
                   consultationhistoryremotecount
                 }
                 consultationhistoryinpersoncount={
                   consultationhistoryinpersoncount
                 }
                 consultationhistorysucccount={consultationhistorysucccount}
               /> */}

                <div className="mt-8 sm:col-span-2 3xl:col-span-2 p-4 px-0 mb-6 lg:mb-0">
                  <div className="flex justify-between items-center mb-6">
                    <p className="capitalize text-coalBlack subHeadingText">
                      Request History
                    </p>
                    <Link to={'/consultation'}>
                      <span className="capitalize text-navLink smallText cursor-pointer">
                        see all
                      </span>
                    </Link>
                  </div>
                  <div className="space-y-3">{consultationBlock}</div>
                </div>
              </div>
            </div>
            <div className="col-span-4  hidden xl:block max-h-[70vh] sticky top-24 ">
              <div className="grid grid-cols-2 gap-3 mb-4">
                <button
                  className="text-white bg-accent baseText flex items-center gap-2 px-4 py-2 rounded-md shadow-card_shadow whitespace-nowrap"
                  onClick={handelCreateRequestBlock}
                >
                  <span className="baseText">+</span>
                  New Request
                </button>
                <select
                  className="bg-accent text-white px-4 py-2 rounded-md shadow-card_shadow"
                  value={notificationFilter}
                  onChange={handleFilterChange}
                >
                  <option
                    value="today"
                    className="text-coalBlack bg-white baseText whitespace-nowrap"
                  >
                    Today
                  </option>
                  <option
                    value="weekly"
                    className="text-coalBlack bg-white baseText whitespace-nowrap"
                  >
                    This Week
                  </option>
                  <option
                    value="monthly"
                    className="text-coalBlack bg-white baseText whitespace-nowrap"
                  >
                    This Month
                  </option>
                </select>
              </div>
              <div className="p-4 rounded-xl h-full relative bg-white shadow-card_shadow">
                <SideMessageNotification
                  data={notification}
                  profileData={profileData}
                  currentdata={currentrequest}
                  setcurrentrequest={setcurrentrequest}
                  viewFunction={handelViewRequestBlockForNotification}
                  notificationfun={() => {
                    getNotification(profileData?.hospitalProfile?._id);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        {/* Dashboard large screen end */}
      </main>
      {/* create request for sm devices  */}
      <div
        className="fixed bottom-20 right-4 z-30 xl:hidden"
        onClick={handelCreateRequestBlock}
      >
        <button className="text-white bg-accent baseText !font-medium flex items-center gap-1 px-4 py-2 rounded-xl whitespace-nowrap ">
          <span className="text-xl">+</span>
          New request
        </button>
      </div>
      {/* create request block  */}
      {createRequestBlock && (
        <Createrequest
          closeFunction={handelCreateRequestBlock}
          editFormValue={null}
          profileData={profileData}
          onload={fetchData}
        />
      )}
      {editRequestBlock && (
        <Createrequest
          closeFunction={handelEditRequestBlock}
          editFormValue={currentrequest}
          profileData={profileData}
          onload={fetchData}
        />
      )}
      {ViewRequestBlock && (
        <ConsultationViewRequest
          currentdata={currentrequest}
          profileData={profileData}
          closeFunction={handelViewRequestBlock}
          onload={onload}
          navigatedFromNotification={openChat ? true : false}
        />
      )}
    </AdminLayout>
  );
}

export default DashboardOdds;
